import Home from './views/Home/Home';
import Dashboard from './views/Dashboard/Dashboard';
import StreetLightControl from './views/StreetLightControl/StreetLightControl';
import PillarControl from './views/PillarControl/PillarControl';
import  DeviceManagement from './views/DeviceManagement/DeviceManagement';
import RadioCoverageStudy from "./views/RadioCoverageStudy/RadioCoverageStudy";
import TimeProgramming from './views/TimeProgramming/TimeProgramming';
import PreventiveMaintenance from './views/PreventiveMaintenance/PreventiveMaintenance';
import StreetCategory from "./views/StreetCategory/StreetCategory";
import NetworkQuality from './views/NetworkQuality/NetworkQuality';
import ParkingSensors from "./views/ParkingSensors/ParkingSensors";
import NetworkTester from "./views/NetworkTester/NetworkTester";
import maintControl from "./assets/citymaint.png";
import Login from "./views/Login/Login";
import About from "./views/About/About";
import SsoLogin from './views/SsoLogin/SsoLogin';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Contact from "./views/Contact/Contact";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

var routes = [
    {
        key: "index",
        path: "/index",
        name: "Αρχική Σελίδα",
        component: <ProtectedRoute><Home /></ProtectedRoute>,
        layout: "/admin",
        icon : "fa fa-home text-info",
    },
    {
        key: "dashboard",
        path: "/dashboard",
        name: "Συγκεντρωτικός Πίνακας",
        component : <ProtectedRoute><Dashboard /></ProtectedRoute>,
        icon : "fa fa-chart-line text-info",
    },
    {
        key: "streetLightControl",
        path: "/streetLightControl",
        name: "Τηλεδιαχείριση Οδοφωτισμού",
        component: <ProtectedRoute><StreetLightControl /></ProtectedRoute>,
        icon : "fa fa-wifi text-info",
    },
    {
        key: "pillarControl",
        path: "/pillarControl",
        name: "Έλεγχος Pillar",
        component: <ProtectedRoute><PillarControl /></ProtectedRoute>,
        icon : "fa fa-sitemap text-info",
    },
    {
        key: "profileAdmin",
        path: "/profileAdmin",
        name: "Διαχείριση Συσκευών",
        component: <ProtectedRoute><DeviceManagement /></ProtectedRoute>,
        icon : "fa fa-lightbulb text-info",
    },
    {
        key: "caseStudy",
        path: "/caseStudy",
        name: "Μελέτη Ραδιοκάλυψης",
        component: <ProtectedRoute><RadioCoverageStudy /></ProtectedRoute>,
        icon : "fa fa-podcast text-info",
    },
    {
        key: "profilePrograms",
        path: "/profilePrograms",
        name: "Χρονοπρογραμματισμός",
        component: <ProtectedRoute><TimeProgramming /></ProtectedRoute>,
        icon : "fa fa-clock text-info",
    },
    {
        key: "flowMaintenance",
        path: "/flowMaintenance",
        name: "Εφαρμογή Προληπτικής Συντήρησης",
        component: <ProtectedRoute><PreventiveMaintenance /></ProtectedRoute>,
        icon : maintControl,
    },
    {
        key: "streetCategory",
        path: "/streetCategory",
        name: "Κατηγοριοποίηση Οδών",
        component: <ProtectedRoute><StreetCategory /></ProtectedRoute>,
        icon : "fa fa-road text-info",
    },
    {
        key: "parkingSensors",
        path: "/parkingSensors",
        name: "Τηλεδιαχείριση Αισθητήρων Πάρκινγκ",
        component: <ProtectedRoute><ParkingSensors /></ProtectedRoute>,
        icon : "fa fa-square-parking text-info",
    },
    {
        key: "netWorkQuality",
        path: "/NetworkQuality",
        name: "Ποιότητα Δικτύου",
        component: <ProtectedRoute><NetworkQuality/></ProtectedRoute>,
        icon : "fa fa-code-fork text-info"
    },
    {
        key: "tester",
        path: "/TestRadioCoverage",
        name: "Tester",
        component: <ProtectedRoute><NetworkTester/></ProtectedRoute>,
        icon : "fa fa-code-fork text-info"
    },
    {
        path: "/About",
        name: "Πληροφορίες",
        component:<About />,
        icon : "fa fa-info-circle text-info",
    },
    {
        key: "contact",
        path: "/Contact",
        name: "Επικοινωνία",
        component:<Contact/>,
        icon : "fa fa-address-book text-info",
    },
    
];

export var authRoutes = 
    [
        {
            path: "/login",
            name: "Σύνδεση",
            component: <Login />,
            layout: "/auth"
        },
        {
            path: "/sso-login/:ssoToken",
            name: "SSO Login",
            component: <SsoLogin />,
            layout: "/auth"
        },
    ];



export default routes;